var defaultOptions = {
  async: false,
  prepend: true
};
/**
 * Creates script element and injects it into the DOM tree.
 * @returns A function that removes the injected script element from the
 * DOM tree when called.
 */

export default function injectJavaScript(source) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  var element = document.createElement('script');
  var head = document.getElementsByTagName('head')[0];
  element.src = source;

  if (options.async) {
    element.async = true;
  }

  if (options.id) {
    element.id = options.id;
  }

  if (options.prepend) {
    head.insertBefore(element, head.childNodes[0]);
  } else {
    head.appendChild(element);
  }

  return function ejectJavaScript() {
    head.removeChild(element);
  };
}
//# sourceMappingURL=injectJavaScript.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/~/@flowio/browser-helpers/dist/esm/injectJavaScript.js
// module id = 631
// module chunks = 0 1